/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ApplicationLicenseStates } from '@jira/platform__license-state/src/license-state.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns the application license states for the current tenant.
 *
 * @agent-skills: tenant-context
 */
export const useLicenseStates = (): ApplicationLicenseStates => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.licenseStates;
};
